'use strict';

module.exports = require('./Slider');


/*****************
 ** WEBPACK FOOTER
 ** ./~/.5.3.5@rc-slider/lib/index.js
 ** module id = 546
 ** module chunks = 0
 **/